/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Is GridCraft? A Guide to the Open-Source Spreadsheet`)
};

const zh_gc_search_guides_what_is_gridcraft_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 GridCraft？开源电子表格使用指南`)
};

/**
* | output |
* | --- |
* | "What Is GridCraft? A Guide to the Open-Source Spreadsheet" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_title as "gc.search_guides.what_is_gridcraft.title" }